'use strict';

module.exports = function ($stateProvider) {
    $stateProvider
    // INBOUND RESP
    .state('pages.main.inbound_resp', {
        url: '/inbound_resp',
        template: require('../views/general_network/inbound_resp.html'),
        controller: 'inboundRespController',
        controllerAs: 'page',
        data: {
            title: 'Inbound Responder Bandwidth Usage',
            daterange: true
        }
    })
    // INBOUND ORIG COUNTRY
        .state('pages.main.inbound_orig_country', {
            url: '/inbound_orig_country',
            template: require('../views/general_network/inbound_orig_country.html'),
            controller: 'inboundOrigCountryController',
            controllerAs: 'page',
            data: {
                title: 'Inbound Originator Country / Responder Bandwidth Usage',
                daterange: true
            }
        })
        // INBOUND ORIG
            .state('pages.main.inbound_orig', {
                url: '/inbound_orig',
                template: require('../views/general_network/inbound_orig.html'),
                controller: 'inboundOrigController',
                controllerAs: 'page',
                data: {
                    title: 'Inbound Originator / Responder Bandwidth Usage',
                    daterange: true
                }
            })
    // OUTBOUND RESP COUNTRY
    .state('pages.main.outbound_resp_country', {
        url: '/outbound_resp_country',
        template: require('../views/general_network/outbound_resp_country.html'),
        controller: 'outboundRespCountryController',
        controllerAs: 'page',
        data: {
            title: 'Outbound Responder Country Bandwidth Usage',
            daterange: true
        }
    })
    // OUTBOUND RESP
        .state('pages.main.outbound_resp', {
            url: '/outbound_resp',
            template: require('../views/general_network/outbound_resp.html'),
            controller: 'outboundRespController',
            controllerAs: 'page',
            data: {
                title: 'Outbound Responder Bandwidth Usage',
                daterange: true
            }
        })
        // OUTBOUND ORIG
            .state('pages.main.outbound_orig', {
                url: '/outbound_orig',
                template: require('../views/general_network/outbound_orig.html'),
                controller: 'outboundOrigController',
                controllerAs: 'page',
                data: {
                    title: 'Outbound Originator / Responder Bandwidth Usage',
                    daterange: true
                }
            })
    // LATERAL RESP
    .state('pages.main.lateral_resp', {
        url: '/lateral_resp',
        template: require('../views/general_network/lateral_resp.html'),
        controller: 'lateralRespController',
        controllerAs: 'page',
        data: {
            title: 'Lateral Responder Bandwidth Usage',
            daterange: true
        }
    })
    // LATERAL ORIG
        .state('pages.main.lateral_orig', {
            url: '/lateral_orig',
            template: require('../views/general_network/lateral_orig.html'),
            controller: 'lateralOrigController',
            controllerAs: 'page',
            data: {
                title: 'Outbound Originator / Responder Bandwidth Usage',
                daterange: true
            }
        })
    // INTERNAL MAP
    .state('pages.main.lateral_map', {
        url: '/lateral_map',
        template: require('../views/general_network/lateral_map.html'),
        controller: 'lateralMapController',
        controllerAs: 'page',
        data: {
            title: 'Lateral Connections Map',
            daterange: true,
            selectrefresh: true
        }
    })
    // SERVICES MAP
    .state('pages.main.services', {
        url: '/services',
        template: require('../views/general_network/services.html'),
        controller: 'servicesController',
        controllerAs: 'page',
        data: {
            title: 'Services',
            daterange: true
        }
    })
    // NETWORK ASSETS
    .state('pages.main.network_assets', {
        url: '/network_assets',
        template: require('../views/general_network/network_assets.html'),
        controller: 'networkAssetsController',
        controllerAs: 'page',
        data: {
                title: 'Network Assets',
                daterange: false
        }
    })

    // JA3
    .state('pages.main.top_ja3', {
        url: '/top_ja3',
        template: require('../views/general_network/top_ja3.html'),
        controller: 'topJA3Controller',
        controllerAs: 'page',
        data: {
                title: 'Top JA3 hashes',
                daterange: false
        }
    })
}




/** WEBPACK FOOTER **
 ** ./src/pages/routes/general_network.js
 **/